/* LEAD DESK FIX-UP (Fix 6a) — one in-app navigation guard for the unsaved call note.
   ORBIT runs on a plain BrowserRouter, so react-router's useBlocker (a data-router feature) is
   not available here; this is the equivalent: the call card registers the guard while the form
   is dirty, internal link clicks are caught in the capture phase, and the lead page's back
   arrow asks through askLeave(). The confirm itself is the card's own dialog, never
   window.confirm on each link. */
let guarded = false;
let dialogHandler = null;

export function setNavGuard(on, handler) {
  guarded = on;
  dialogHandler = on ? handler : null;
}

export function isNavGuarded() {
  return guarded;
}

export function askLeave(proceed) {
  if (!guarded) { proceed(); return; }
  if (dialogHandler) dialogHandler(proceed);
}
